import React, { useEffect, useState } from 'react';
import { NCZIComposition, NCZIEntry } from '../../../../Interfaces/ncziTypes';
import EHRCompositionInfo from './EHRCompositionInfo';
import EHRCompositionItem from './EHRCompositionItem';
import { joinClasses } from '../../../../../../Utils/className.util';
import Tooltip from '../../../../../../Components/Popup/Tooltip';
import Text from '../../../../../../Components/Base/Text/Text';
import EHREntryItem from '../EHREntry/EntryItem/EHREntryItem';

// @ts-ignore
import styles from './EHRComposition.module.scss';
// @ts-ignore
import entryStyles from '../EHREntry/EHREntry.module.scss';

interface Props {
	item: NCZIComposition | undefined;
}

const EHRComposition: React.FC<Props> = props => {
	const { item } = props;
	const [skipCompositionDisplay, setSkipCompositionDisplay] =
		useState<boolean>(false);

	if (!item) {
		return <></>;
	}

	useEffect(() => {
		if (item.items.length === 1 && item.items[0].entry) {
			setSkipCompositionDisplay(true);
		}
	}, []);

	const sensitivity = item.sensitivity && (
		<div
			className={joinClasses([
				styles.compositionSensitivity,
				styles['s' + item.sensitivity],
			])}>
			<Tooltip trigger={<>{item.sensitivity}</>}>
				<Text tx={'nczi.sensitivity'} inline />: {item.sensitivity}/5
			</Tooltip>
		</div>
	);

	if (skipCompositionDisplay) {
		const entry = item.items[0].entry as NCZIEntry;
		return (
			<div className={styles.wrapper}>
				<div className={styles.header}>
					<div className={styles.compositionName}>{entry.name}</div>
					{sensitivity}
				</div>
				<div className={entryStyles.wrapper}>
					<EHRCompositionInfo info={item.info} />
					{entry.items.map((entryItem, key) => (
						<EHREntryItem item={entryItem} key={key} />
					))}
				</div>
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<div className={styles.compositionName}>{item.name}</div>
				{sensitivity}
			</div>
			<EHRCompositionInfo info={item.info} />
			{item.items.map((compositionItem, key) => (
				<EHRCompositionItem item={compositionItem} key={key} />
			))}
		</div>
	);
};

export default EHRComposition;
